import React, { Component } from "react";
import "./EditProfile.css";
import "./RetnetRegister.css";
import UserProfile from "./UserProfile";
import ProfessionalDetails from "./ProfessionalDetails";
import LoaderButton from "../components/LoaderButton";
import config from "../config";
import { API } from "aws-amplify";
import { s3Upload } from "../libs/awsLib";



export default class RetnetLiveWebLink extends Component {

    validateForm(){
        return true;
    }

    constructor(props){
        super(props);
        this.payliveconf = React.createRef();

        this.state = {
            isLoading: false,
            fullname : "",
            age: "",
            otherpersonname: "NA",
            otherpersonphone: "NA",
            secondpersonname: "NA",
            secondpersonphone: "NA",
            gender: "Female",
            medicalregno: "",
            hospital: "",
            delegatetype: "NA",
            food: "NA",
            totalPayment: "1,000",
            preconference: "false",
            preconferenceUI: false,
            reservationType: "RetnetLive",
            hotelBooking: "NA"

        };


    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });

    }


    submitPersonalDetails = async event => {
        event.preventDefault();

        try{

            if(this.state.fullname.length === 0){
                this.setState({errorMsg: "Please enter your name"});
                return;
            }

            if(this.state.age.length === 0){
                this.setState({errorMsg: "Please enter your age"});
                return;
            }


            if(this.state.medicalregno.length === 0){
                this.setState({errorMsg: "Please enter your medical council registration number"});
                return;
            }

            if(this.state.hospital.length === 0){
                this.setState({errorMsg: "Please enter the hospital where you work"});
                return;
            }

            if(this.state.otherpersonname.length === 0){
                this.state.otherpersonname = "NA";
            }

            this.setState({isLoading: true});
            await this.createBooking(this.state);
            this.payliveconf.current.click();

        }catch(e){

            this.setState({isLoading: false, errorMsg: "Something went wrong. Please contact our support team."});
        }
    }


    async createBooking(bookingDetails){
        var registrationDetails = await API.post("retnetindia", "/register4retnet", {
            body: bookingDetails
        });
        localStorage.setItem("registrationId", registrationDetails.registrationId);
        return registrationDetails;
    }

    getSuccessNotification(successMsg){
        return this.state.successMsg && this.state.successMsg.length > 0
            ? <div className="alert alert-success" role="alert">
                {this.state.successMsg}
            </div>
            : "";
    }

    getErrorElement(){
        return this.state.errorMsg && this.state.errorMsg.length > 0
            ? <div className="alert alert-danger" role="alert">
                {this.state.errorMsg}
            </div>
            : "";
    }



    render() {
        //Test payment link: https://test.instamojo.com/@srivardhan_sunkesula/l517721faa7c747b3ae0f642365d3178
        return(
            <div className="container">
                <div className="retnet-center-text retnet2020title">
                    For any queries or concerns please contact &nbsp;
                    <b>Dr. Divyansh Mishra (+91-8977405171)</b> or <b> Mr. Ravindra (+91-9880541133) </b>
                </div>

                <div className="row ">
                    <div className="col-md-2"></div>
                    <div className="col-md-8 profile-update-widget">
                        <div className="card">
                            <div className="card-title b-xs-bottom">
                                <h3 className="retnet-center-text">RETNET INDIA MEET 2023</h3>
                                <p className="retnet-center-text">Zoom meeting link will be sent to your email after payment is verified.</p>

                            </div>
                            <div className="card-body">
                                {this.getErrorElement()}
                                {this.getSuccessNotification()}
                                <form id="personal-details-form"
                                      onSubmit={this.submitPersonalDetails}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label for="fullname"> <span className="retnet2020title">*&nbsp;</span> Full Name</label>
                                                <input type="text" id="fullname"
                                                       className="form-control"
                                                       placeholder=""
                                                       onChange={this.handleChange} />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label for="gender">Select Gender</label>
                                                <select className="form-control"
                                                        id="gender"
                                                        onChange={this.handleChange}>
                                                    <option value="Female">Female</option>
                                                    <option value="Male">Male</option>

                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label for="age"><span className="retnet2020title">*&nbsp;</span> Age</label>
                                                <input type="number" id="age"
                                                       className="form-control"
                                                       placeholder=""
                                                       onChange={this.handleChange} />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            {/*<div className="form-group">*/}

                                            {/*    <label for="food">Food Preference</label>*/}
                                            {/*    <select className="form-control"*/}
                                            {/*            id="food"*/}
                                            {/*            onChange={this.handleChange}>*/}
                                            {/*        <option value="Vegetarian">Vegetarian</option>*/}
                                            {/*        <option value="NonVegetarian">Non Vegetarian</option>*/}

                                            {/*    </select>*/}

                                            {/*</div>*/}
                                        </div>
                                    </div>

                                    <br/>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label for="medicalregno"><span className="retnet2020title">*&nbsp;</span>Medical Council Reg No</label>
                                                <input type="text" id="medicalregno"
                                                       className="form-control"
                                                       placeholder=""
                                                       onChange={this.handleChange} />
                                            </div>

                                        </div>
                                        <div className="col-md-6">

                                            <div className="form-group">
                                                <label for="hospital"> <span className="retnet2020title">*&nbsp;</span> Working Hospital</label>
                                                <input type="text" id="hospital"
                                                       className="form-control"
                                                       placeholder=""
                                                       onChange={this.handleChange} />
                                            </div>

                                        </div>
                                    </div>

                                    {/*<div className="checkbox">*/}
                                    {/*    <input type="checkbox"*/}
                                    {/*           name="preconference"*/}
                                    {/*           onChange={this.handleWorkshop}*/}
                                    {/*           checked={this.state.preconferenceUI}*/}
                                    {/*           id="preconference"  />*/}
                                    {/*    <label for="preconference" className="retnet2020title preconferenceText" >*/}
                                    {/*        Include Pre-Conference Workshop on Diabetic Vitrectomy on 6th August at 9 AM &nbsp; <b className="blink_me"> (+ &#x20B9;1,000) </b>*/}
                                    {/*        Limited Seats Available*/}
                                    {/*    </label>*/}
                                    {/*</div>*/}
                                    <br />
                                    Charges Includes:
                                    <ul >
                                        <li>Retnet 2023 Live Zoom Link</li>
                                    </ul>

                                    <div className="form-group align-center">
                                        <h4>Your Total Payment : &#x20B9; {this.state.totalPayment}</h4>
                                        <LoaderButton block bsStyle="primary" bsSize="large"
                                                      disable={!this.validateForm()} type="submit"
                                                      isLoading={this.state.isLoading} text="Pay Now"
                                                      loadingText="Pay Now"
                                                      className="btn btn-primary"/>


                                        <div hidden>
                                            <a href="https://imjo.in/YgPG3X"
                                               rel="im-checkout" data-text="Pay"
                                               ref={this.payliveconf}
                                               data-css-style="color:#ffffff; background:#75c26a; width:300px; border-radius:4px"
                                               data-layout="vertical" >
                                            </a>


                                        </div>

                                    </div>


                                </form>
                                <div className="checkbox">
                                    <input type="checkbox"
                                           name="newsletter"
                                           id="newsletter"  />
                                    <label for="newsletter" className="" >
                                        I want to subscribe for RETNET Conference Newsletter.
                                    </label>
                                </div>
                                <br />
                                <div className="retnet2020title">* Indicates Mandatory Fields

                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                    {/*<div className="col-md-4">*/}
                    {/*    <img className="retnet-banner" src="/images/preconferenceworkshop.jpg" />*/}

                    {/*</div>*/}
                </div>

                <br />
                <br />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/RetnetLiveWebLink.js